<template>
  <v-card flat class="px-5">
    <ValidationObserver ref="observer">
      <template v-for="field in fields" >

        <div :key="field.title" class="text-subtitle-1 text-button my-7">
          {{ field.title }}
        </div>
        <v-row dense>
          <v-col cols="4" v-for="detail in field.details" :key="detail.name">
            <ValidationProvider
              :name="detail.label"
              :rules="detail.rules"
              events="['blur']"
              v-slot="{ errors }"
            >
              <v-select
                v-if="detail.type ==='select'"
                :label="detail.label + detail.rules.includes('required') ? '*':''"
                v-model="details[detail.value]"
                outlined
                dense
                :items="detail.items"
                :error-messages="errors"
              />
              <v-text-field
                v-else-if="detail.type ==='date'"
                :label="detail.label + detail.rules.includes('required') ? '*':''"
                type="date"
                v-model="details[detail.value]"
                outlined
                dense
                :error-messages="errors"
              />
              <v-text-field
                v-else
                :label="detail.label + detail.rules.includes('required') ? '*':''"
                v-model="details[detail.value]"
                outlined
                dense
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>

        </v-row>
      </template>
    </ValidationObserver>
  </v-card>
</template>

<script>
import { MEMBER_CATEGORIES } from '@/lib/constants/options';

export default {
  data() {
    return {
      details: {},
      fields: [  // Person Details
        {
          title: '',
          details: [
            {
              label: "First Name",
              value: "firstName",
              rules: "required"
            },
            {
              label: "Middle Name",
              value: "middleName",
              rules: ""
            },
            {
              label: "Last Name",
              value: "lastName",
              rules: "required"
            },
            {
              label: "TRN",
              value: "trn",
              rules: "required"
            },
            {
              type: 'select',
              label: "Gender",
              value: "gender",
              rules: "",
              items: ['Male', 'Female']
            },
            {
              type: 'date',
              label: "Date of Birth",
              value: "dateOfBirth",
              rules: "date"
            },
            {
              type: 'select',
              label: "Member Status",
              value: "memberCategory",
              rules: "",
              items: MEMBER_CATEGORIES
            }
          ]
        },
        // Address Details
        {
          title: 'Address',
          details: [
            {
              label: "Street Name",
              value: "street",
              rules: ""
            },
            {
              label: "Town",
              value: "city",
              rules: ""
            },
            {
              label: "Province",
              value: "province",
              rules: ""
            },
            {
              label: "Country",
              value: "country",
              rules: ""
            }
          ]
        }
      ]
    }
  },

  methods: {
    clear() {
      this.details = {}
    },

    async validate() {
      return this.$refs.observer.validate();
    },

    submit() {
      this.$emit('submit', this.details)
    }
  }
}

</script>